import React from 'react';
import { Link } from 'react-router-dom';

const FilmCard = ({ film }) => {
  // Gestion de la durée même si non définie
  const formatDuration = () => {
    if (!film.duration) return "Durée N/A";
    
    const hours = Math.floor(film.duration / 60);
    const minutes = film.duration % 60;
    
    return `${hours}h${minutes > 0 ? ` ${minutes}min` : ''}`;
  };
  
  // Déterminer si le film est nouveau (moins de 30 jours)
  const isNewRelease = () => {
    if (!film.releaseDate) return false;
    
    const releaseDate = new Date(film.releaseDate);
    const now = new Date();
    const diffTime = now - releaseDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);
    
    return diffDays <= 30;
  };
  
  // Permet aussi d'ajouter un badge "À l'affiche" via la propriété featured
  const showBadge = isNewRelease() || film.featured;
  const badgeText = isNewRelease() ? "Nouveau" : "À l'affiche";
  
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md transition-transform hover:scale-105">
      <div className="relative">
        <Link to={`/films/${film.id}`}>
          <img 
            src={film.poster || "/images/placeholder-poster.jpg"} 
            alt={`Affiche du film ${film.title}`}
            className="w-full h-48 object-cover"
          />
        </Link>
        
        {/* Badge conditionnel */}
        {showBadge && (
          <div className="absolute top-2 left-2 bg-amber-500 text-white text-xs font-bold px-2 py-1 rounded">
            {badgeText}
          </div>
        )}
      </div>
      
      <div className="p-4">
        <div className="flex justify-between items-start">
          <Link to={`/films/${film.id}`}>
            <h3 className="font-bold text-lg leading-tight hover:text-amber-600 transition">{film.title}</h3>
          </Link>
          <span className="bg-gray-100 text-xs px-2 py-1 rounded">{film.year || "N/A"}</span>
        </div>
        
        <p className="text-gray-600 text-sm mt-1">Réalisé par {film.director || "Inconnu"}</p>
        
        <div className="flex items-center mt-2 text-sm text-gray-500">
          <span className="mr-3">{film.genre || "Genre N/A"}</span>
          <span>{formatDuration()}</span>
        </div>
        
        <div className="mt-4 flex justify-between items-center">
          <Link 
            to={`/films/${film.id}`} 
            className="bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-medium transition"
            aria-label={`Regarder le film ${film.title}`}
          >
            Regarder
          </Link>
          {film.associatedProject && (
            <Link 
              to={`/projets/${film.associatedProject}`} 
              className="text-amber-600 hover:text-amber-700 text-sm underline"
              aria-label={`Voir le projet associé au film ${film.title}`}
            >
              Voir le projet
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilmCard;
